import { render, staticRenderFns } from "./ActivityReportingInformation.vue?vue&type=template&id=295d4876&scoped=true&"
import script from "./ActivityReportingInformation.vue?vue&type=script&lang=js&"
export * from "./ActivityReportingInformation.vue?vue&type=script&lang=js&"
import style0 from "./ActivityReportingInformation.vue?vue&type=style&index=0&id=295d4876&lang=less&"
import style1 from "./ActivityReportingInformation.vue?vue&type=style&index=1&id=295d4876&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295d4876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295d4876')) {
      api.createRecord('295d4876', component.options)
    } else {
      api.reload('295d4876', component.options)
    }
    module.hot.accept("./ActivityReportingInformation.vue?vue&type=template&id=295d4876&scoped=true&", function () {
      api.rerender('295d4876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/terminalActivity/MarketActivityComponents/ActivityReportingInformation.vue"
export default component.exports